import { render } from "./Footer.vue?vue&type=template&id=a2e5ddac&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/styles/footer.css?vue&type=style&index=0&id=a2e5ddac&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=1&id=a2e5ddac&scoped=true&lang=css&external"
import "./Footer.vue?vue&type=style&index=2&id=a2e5ddac&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Desktop/중요/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2e5ddac"]])

export default __exports__